import { render } from "./LangSwitch.vue?vue&type=template&id=28032cb2&scoped=true"
const script = {}

import "./LangSwitch.vue?vue&type=style&index=0&id=28032cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28032cb2"]])

export default __exports__